module.exports = __webpack_public_path__ + "img/shequ-1.e5fd4999.png";